import _ from "lodash";
import { Response } from "models";
import { toast } from "react-toastify";

export const mapServerErrors = (response: Response) => {
  let errors: any = {others:[]};

  response.errors.forEach((error) => {
    const { fieldName } = error;
    if (fieldName) {
      errors[_.camelCase(fieldName)] = error.code;
    } else {
      errors.others.push(error.message);
    }
  });

  if (_.isEmpty(errors.others)) {
    delete errors.others;
    toast.error('Server Error');
  }
  else errors.others.forEach((err: string) => toast.error(err));

  return errors;
};
